import React from 'react';
import {BrowserRouter as Router, Route, Link, Switch} from 'react-router-dom'
import Display from '../helpers/display'
import Loading from '../loading';

class ProfilePreview extends React.Component {

	// constructor(props) {
	// 	super(props);
	// }

	componentDidMount() {
		// console.log("profile",this.props.profile)
	}

	render() {
		if (!this.props.profile || !this.props.profileId) return '';

		let profile = this.props.profile;

		return <Link to={`/game/${this.props.gameId}/profile/${this.props.profileId}/`} className="profile">
		<h4 className="rank">{this.props.rank}</h4>
		<h3 className="name">{profile.name}</h3>
		<h4 className="value">
		{this.props.show === 'wallet' && <span className="amount">${Display.walletTotal(profile.transactions)}</span>}
		{this.props.show === 'education' && <span className={Display.educationName(profile.education)}>{Display.educationName(profile.education)}</span>}
		{this.props.show === 'permission' && <span className="label -secondary">Leader</span>}
		</h4>
		</Link>
	}
}

export default ProfilePreview



// WEBPACK FOOTER //
// ./src/components/game/profile.preview.js